import React, { useEffect } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Divider from '@mui/material/Divider';
import CardMedia from '@mui/material/CardMedia';

export default function LicenseView(props) {
  const { open, handleClose, licenseFileName } = props;

  useEffect(async () => {}, [open]);

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="draggable-dialog-title">
      <DialogTitle id="draggable-dialog-title">사업자등록증</DialogTitle>
      <DialogContent dividers>
        <Divider />
        <CardMedia component="img" image={'/api/license/' + licenseFileName} style={{ border: '1px solid' }} />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="success" onClick={handleClose}>
          닫기
        </Button>
      </DialogActions>
    </Dialog>
  );
}
